import { RoomDelegator } from "../RoomDelegator";
import { RoomValidator } from "./types";

/**
 * Validates the room state. Throws a {@link RoomValidationError} if the room is
 * invalid. The caller should leave the room if an error is thrown.
 */
export async function validateRoom(
  room: RoomDelegator,
  validators: RoomValidator[],
) {
  for (const validator of validators) {
    const [isValid, error] = await validator(room);
    if (!isValid) {
      throw error;
    }
  }
}
